import React, { useState, useEffect, useRef } from "react";
// import { startTransition } from "react";

import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { v4 as uuidv4 } from "uuid";

import { useAppSelector, useAppDispatch } from "../../hooks/store";
import { Auth } from "../../auth/auth";

import Typography from "../../components/Typography/Typography";
import SearchInput from "../../components/SearchInput/SearchInput";
import UploadDoc from "../../components/UploadDoc/UploadDoc";
import Button from "../../components/Button/Button";
import SideDrawer from "../../components/SideDrawer/SideDrawer";
import {
  RFX_GENERATOR_ACTIONS,
  CONTRACT_REVIEW_ACTIONS,
  storeChatHistory,
} from "../../modules/vscDashboard/store/dashboard.thunk";

import { DASHBOARD_ENTITIES, LOCAL_STORAGE_KEYS } from "../../common/constants";
import { ROUTES } from "../../common/constants";

import AgenticChatbot from "./AgenticChatbot.module.scss";
import { AgenticChatbotConstants } from "./constants";
import CloseIcon from "../../assets/cross_dark.svg";
import ConversationHistoryIcon from "../../assets/conversation_history.svg";
import BackArrowIcon from "../../assets/backArrowIcon.svg";
import ChatbotBackground from "../../assets/chatbot-background.svg";
import UploadIcon from "../../assets/images/uploadIconOutlined.svg";
import Orion from "../../assets/Orion Logo.svg";
import xlsxIcon from "../../assets/xlsxIcon.svg";
import NewChatIcon from "../../assets/newChatIcon.svg";
import Doc from "../../assets/docIcon.svg";
import {
  cleanChatHistory,
  getChatHistory,
  getPreviousConversations,
  initialPostCall,
} from "../../services/agent.service";
import {
  storeDocId,
  emptyList,
  saveLoaderState,
  handleUseEffectCount,
  storeFileId,
} from "../vscDashboard/store/dashboard.thunk";
import { render } from "@testing-library/react";
import JSON5 from "json5";
import {
  getPreviousConversationsThunk,
  updateConvHistoryShowStatusThunk,
} from "./store/agenticchatbot.thunk";
import { CircularProgress } from "@mui/material";
type AgenticChatbotProps = {
  isOpen: boolean;
  toggleDrawer: (
    open: boolean
  ) => (event?: React.KeyboardEvent | React.MouseEvent) => void;
  // chatHistory: any[]; // Assuming chatHistory is an array of messages
  //   startMessage: string;
  showAllButtons: string[]; // Assuming showAllButtons is an array of strings
  setChatHistory: any;
};

interface Message {
  id: string;
  text: string;
  sender: "user" | "assistant" | "";
  timestamp: Date;
  hasLink?: boolean;
  linkText?: string;
  linkUrl?: string;
  remainingText?: string;

  loading?: boolean;
  hasUploadButton?: boolean;
  fileIcon?: string;
  showReviewButton?: boolean;
  hasReviewButton?: boolean;
  generating?: boolean; // New property to indicate if the message is generating
  contractReviewLoader?: boolean;
  radioFileList?: string[]; // New property for radio file list
}
type ChatHistoryDocument = {
  doc_id: string;
  file_name: string;
};

const ConversationHistoryCard = ({
  data,
  handlePreviousConversationClick,
}: any) => {
  return (
    <div
      onClick={async () => await handlePreviousConversationClick(data?.convId)}
      className={AgenticChatbot.historyCard}
    >
      <div className={AgenticChatbot.cardHeader}>
        <div className={AgenticChatbot.date}> {data?.date} </div>
      </div>
      <div className={AgenticChatbot.cardBody}>
        <div className={AgenticChatbot.title}>
          <Typography className={AgenticChatbot.heading}>
            {data?.title}
          </Typography>

          <Typography className={AgenticChatbot.time}>{data?.time}</Typography>
        </div>
        <Typography className={AgenticChatbot.subtitle}>
          {data?.subtitle}
        </Typography>
      </div>
    </div>
  );
};

const ConversationHistory = ({
  showConversationHistory,
  handleConversationHistoryClick,
  handleClose,
  handlePreviousConversationClick,
}: any) => {
  const { previousConversations } = useAppSelector(
    (store) => store.rootReducer.agenticChatBotReducer
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getPreviousConversationsThunk());
  }, []);

  return (
    <div
      className={`${AgenticChatbot.recentConversationWrapper} ${
        showConversationHistory ? AgenticChatbot.show : ""
      } `}
    >
      <div className={AgenticChatbot.header}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={BackArrowIcon}
            alt=""
            onClick={handleConversationHistoryClick}
          />
          <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>
            {AgenticChatbotConstants.CHAT_HISTORY}
          </Typography>
        </div>
        <img src={CloseIcon} alt="" onClick={handleClose} color="red" />
      </div>
      <div className={AgenticChatbot.body}>
        {previousConversations?.listData ? (
          previousConversations?.listData?.map((conv: any) => {
            return (
              <ConversationHistoryCard
                handlePreviousConversationClick={
                  handlePreviousConversationClick
                }
                data={conv}
              />
            );
          })
        ) : (
          <div className={AgenticChatbot.cardListLoader}>
            <CircularProgress />
          </div>
        )}
      </div>
    </div>
  );
};

export default function SwipeableTemporaryDrawer({
  isOpen,
  toggleDrawer,
  // chatHistory,
  showAllButtons,
}: // setChatHistory,
//   startMessage,
AgenticChatbotProps) {
  const {
    fileUpload,
    file_name: fileName,
    docId,
    generating,
    call,
    fileIdReview,
    fileNameReview,
  } = useAppSelector((store) => store?.rootReducer?.vscDashboardReducer)
    ?.contractDrafting as {
    fileUpload: {
      error?: {
        response?: {
          data?: {
            error?: string;
          };
        };
      };
      uploaded?: boolean;
      docId?: string;
    };
    docId: string;
    file_name: string;
    generating?: boolean;
    call: boolean;
    fileIdReview: string;
    fileNameReview: string; // <-- Added to reflect fileNameResponse
  };

  const {
    pending_documents: {
      fileUpload: contractsReviewFileUpload,
      list: reviewList,
      docId: contractsReviewDocId,
    },
    chatHistory: chatHistory,
    reviewing,
  } = useAppSelector(
    (store) => store?.rootReducer?.vscDashboardReducer?.contractsReview
  ) as {
    pending_documents: {
      fileUpload: {
        error?: {
          response?: {
            data?: {
              error?: string;
            };
          };
        };
        uploaded?: boolean;
      };
      list?: any;
      docId?: string;
    };
    chatHistory?: any[]; // Assuming chatHistory is an array of messages
    reviewing?: boolean;
  };

  const dateTimeValue = localStorage.getItem("DATE_TIME_FORMAT");
  const conversationId = localStorage.getItem(
    LOCAL_STORAGE_KEYS.AGENTIC_CONVERSATION_ID
  );
  const [activeConversationId, setActiveConversationId] =
    useState(conversationId);
  const auth = Auth.getInstance();
  const accessToken = auth.getGoogleAccessToken();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const [disableRadioOptions, setDisableRadioOptions] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [inputValue, setInputValue] = useState<string>("");
  const [showButtons, setShowButtons] = useState<string[]>([]);
  const [showHistoryButton, setShowHistoryButton] = useState<boolean>(false);
  const [fileId, setFileId] = useState<string>("");

  const [fileNameResponse, setFileName] = useState<string>("");
  const [uploadIntakeClicked, setUploadIntakeClicked] =
    useState<boolean>(false);
  const [reviewButtonClicked, setReviewButtonClicked] =
    useState<boolean>(false);
  const [review, setReview] = useState<boolean>(false);
  const [uploadContractClicked, setUploadContractClicked] =
    useState<boolean>(false);
  const [selectedDocId, setSelectedDocId] = useState<string>("");
  const [selectedFileName, setSelectedFileName] = useState<string>("");
  const [isCallPending, setIsCallPending] = useState(false);
  const [hasTypedAndSent, setHasTypedAndSent] = useState(false);
  const [reviewStepIndex, setReviewStepIndex] = useState(0);

  const { showConversationHistory } = useAppSelector(
    (store) => store.rootReducer.agenticChatBotReducer
  );

  const hasRunOnceRef = useRef(false);
  const hasCalledApi = useRef(false);

  // Simulating the "Reviewing Contract" Constants message till API response fetched
  useEffect(() => {
    const isReviewingContract = messages.some(
      (msg) => msg.loading && msg.contractReviewLoader
    );

    let interval: NodeJS.Timeout | null = null;

    if (isReviewingContract) {
      setReviewStepIndex(0);
      interval = setInterval(() => {
        setReviewStepIndex((prev) =>
          prev < AgenticChatbotConstants.REVIEWING_CONTRACT_STEPS.length - 1
            ? prev + 1
            : prev
        );
      }, 5000);
    } else {
      setReviewStepIndex(0);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [messages]);

  useEffect(() => {
    if (call) {
      dispatch(handleUseEffectCount(false));
      if (!isOpen) {
        // Drawer just closed: reset everything
        setMessages([]);
        setShowButtons([]);

        return;
      }
      if (isOpen) {
        // Add one loading message
        setActiveConversationId(
          localStorage.getItem(LOCAL_STORAGE_KEYS.AGENTIC_CONVERSATION_ID)
        );
        // const loaderMsgId = `assistant-initial-${Date.now()}`;
        // setMessages([
        //   {
        //     id: loaderMsgId,
        //     text: "",
        //     sender: "assistant",
        //     timestamp: new Date(),
        //     loading: true, // triggers the 3-dot loader
        //   },
        // ]);

        // Only trigger if the drawer is opened AND chatHistory is empty

        if (!hasRunOnceRef.current && (chatHistory?.length ?? 0) === 0) {
          hasRunOnceRef.current = true;

          setIsCallPending(true);

          // Add one loading message
          const loaderMsgId = `assistant-initial-${Date.now()}`;
          setMessages([
            {
              id: loaderMsgId,
              text: "",
              sender: "assistant",
              timestamp: new Date(),
              loading: true, // triggers the 3-dot loader
            },
          ]);

          (async () => {
            try {
              const query = AgenticChatbotConstants.INITIAL_QUERY;
              const response = await initialAgenticAICall(
                query,
                activeConversationId
              );

              // Update loader message with API response
              setMessages((prev) =>
                prev.map((m) =>
                  m.id === loaderMsgId
                    ? {
                        ...m,
                        text: response?.message_to_user,
                        loading: false,
                      }
                    : m
                )
              );

              // Show user-chosen buttons
              if (response?.list_of_suggested_options) {
                setShowButtons(response?.list_of_suggested_options);
                setOptions([]);
              }
            } catch (error) {
              setShowButtons([]);
              setMessages((prev) =>
                prev.map((m) =>
                  m.id === loaderMsgId
                    ? {
                        ...m,
                        text: "Failed to load. Please try again.",
                        loading: false,
                      }
                    : m
                )
              );
            } finally {
              setIsCallPending(false);
            }
          })();
        } else if (!isOpen) {
          // Drawer closed: reset messages or do nothing
          setMessages([]);
          setShowButtons([]);
        }
      }
    }
  }, [isOpen, activeConversationId]);

  const handleFileUpload = (file: File) => {
    setUploadedFile(file);
  };

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleUserMessage = async (message: string) => {
    setOptions([]);
    // startTransition(() => setInputValue("")); // Let React prioritize UI update

    setInputValue("");
    // setShowButtons(false);

    if (message.trim()) {
      setHasTypedAndSent(true);
    }
    setIsCallPending(true);

    setShowButtons([]); // Resetting the buttons
    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: message,
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);

    // b) Add a loader message for the assistant's response
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
    };
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const extra_data = {
        drafted_contract_file_id: fileIdReview,
        oauth_token: accessToken,
        drafted_contract_file_name: fileNameReview,
      };
      let response: any;

      if (fileIdReview && fileName) {
        response = await initialAgenticAICall(
          message,
          activeConversationId,
          extra_data
        );
        dispatch(storeFileId({ fileId: "", fileNameResponse: "" })); // Resetting fileId and fileNameResponse
      } else {
        response = await initialAgenticAICall(message, activeConversationId);
      }
      // d) Update the loader message with the response

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user || "No response received",
                loading: false,
                ...(Array.isArray(response?.documents) &&
                response.documents.length > 0
                  ? { radioFileList: response.documents }
                  : {}),
              }
            : msg
        )
      );
      setIsCallPending(false);
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
      if (
        response?.contract_reviewed_doc_id &&
        response?.contract_reviewed_file_id &&
        !response?.error_message
      ) {
        let url = ROUTES.doc + "?url=" + response?.contract_reviewed_doc_id;

        dispatch(storeDocId(response?.contract_reviewed_doc_id || ""));
        navigate(
          url +
            "&backurl=" +
            ROUTES.manageContracts +
            "&tab=review_pending_dashboard",
          { state: { keepDrawerOpen: true } }
        );
      }
    } catch (error) {
      // fallback if something fails
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: "Error occurred. Please try again.",
                loading: false,
              }
            : msg
        )
      );
    }
  };

  const handleDraftContractClick = async () => {
    setReviewButtonClicked(false);
    setShowButtons([]); // Resetting the buttons
    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: "Draft Contract",
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);

    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
    };
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = AgenticChatbotConstants.CREATE_DRAFT;

      const response = await initialAgenticAICall(query, activeConversationId);
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user,

                loading: false,
              }
            : msg
        )
      );
      setIsCallPending(false);
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
    } catch (err) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId ? { ...msg, loading: false } : msg
        )
      );
    }
  };

  const handleReviewContractClick = async (agentResponse: any = null) => {
    // if(fileId || fileIdReview){
    //   dispatch(storeFileId({ fileId: fileId ? fileId : fileIdReview, fileNameResponse: fileNameResponse ? fileNameResponse : fileNameReview })); // <-- Updated to include fileNameResponse

    // }
    setReview(true);
    setShowButtons([]); // Resetting the buttons
    setMessages((prev) => [
      ...prev,
      {
        id: `user-${Date.now()}`,
        text: "Review Contract",
        sender: "user",
        timestamp: new Date(),
      },
    ]);
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
    };
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = "Review Contract which is drafted now";
      const extra_data = {
        drafted_contract_file_id: fileIdReview, // fileId ||
        oauth_token: accessToken,
        drafted_contract_file_name: fileNameReview, //fileName ||
      };

      if (
        agentResponse?.drafted_contract_file_id &&
        agentResponse?.drafted_contract_file_name
      ) {
        extra_data.drafted_contract_file_id =
          agentResponse?.drafted_contract_file_id;
        extra_data.drafted_contract_file_name =
          agentResponse?.drafted_contract_file_name;
      }

      const response = await initialAgenticAICall(
        query,
        activeConversationId,
        extra_data
      );
      setFileId("");
      setFileName("");
      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: {
          docId: "",
        },
      });
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.DELETE_DOCUMENT_ID,
        payload: {
          docId: "",
        },
      });

      let url = ROUTES.doc + "?url=" + response?.contract_reviewed_doc_id;

      dispatch(storeDocId(response?.contract_reviewed_doc_id || ""));
      if (
        !response?.error_message &&
        response?.contract_reviewed_doc_id &&
        response?.contract_reviewed_file_id
      ) {
        navigate(
          url +
            "&backurl=" +
            ROUTES.manageContracts +
            "&tab=review_pending_dashboard",
          { state: { keepDrawerOpen: true } }
        );
      }
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user,

                loading: false,
                // hasReviewButton: true,
              }
            : msg
        )
      );
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
      // dispatch(storeDocId(""));
      setIsCallPending(false);
    } catch (err) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId ? { ...msg, loading: false } : msg
        )
      );
    }
  };

  const handleReviewContractClickInitial = async () => {
    setFileId("");
    setFileName("");
    dispatch(storeFileId({ fileId: "", fileNameResponse: "" })); // Provide appropriate values for fileId and fileNameResponse
    setShowButtons([]);
    // setShowButtons(false);
    setReviewButtonClicked(true);
    setMessages((prev) => [
      ...prev,
      {
        id: `user-${Date.now()}`,
        text: "Review Contract",
        sender: "user",
        timestamp: new Date(),
      },
    ]);
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
    };
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = AgenticChatbotConstants.REVIEW;
      const extra_data = {
        doc_id: "",
      };
      const response = await initialAgenticAICall(
        query,
        activeConversationId,
        extra_data
      );

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user,

                loading: false,
                // hasReviewButton: true,
              }
            : msg
        )
      );

      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
      setIsCallPending(false);
    } catch (err) {
      setShowButtons([]);
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId ? { ...msg, loading: false } : msg
        )
      );
    }
  };
  const handleUploadClick = () => {
    setUploadIntakeClicked(true);
    setOpenModal(true);
    setLoading(true);
  };
  const hasShownErrorRef = useRef(false);

  useEffect(() => {
    const hasError =
      fileUpload?.error && Object.keys(fileUpload?.error).length > 0;

    if (!hasError) {
      hasShownErrorRef.current = false;
      return;
    }

    // Show error only once.
    if (hasError && !hasShownErrorRef.current) {
      hasShownErrorRef.current = true;
      setOpenModal(false);
      setShowButtons([]);
      const loaderMsgId = `assistant-initial-${Date.now()}`;
      // 1) Show file name from user first

      // 1. Add error message and loader message
      setMessages((prev) => [
        ...prev,
        {
          id: `user-file-${Date.now()}`,
          text: fileName,
          sender: "user",
          timestamp: new Date(),
          fileIcon: fileName && xlsxIcon,
        },
      ]);

      // 2) Then show the assistant error message
      setMessages((prev) => [
        ...prev,
        {
          id: `assistant-error-${Date.now()}`,
          text: "You have uploaded an incorrect intake form. Please upload the correct intake form to draft the contract.",
          sender: "assistant",
          timestamp: new Date(),
          loading: false,
        },
      ]);
      setShowButtons([AgenticChatbotConstants.UPLOAD_INTAKE_FORM]);
    }
  }, [
    uploadIntakeClicked,
    fileUpload?.error && Object.keys(fileUpload?.error).length > 0,
  ]);

  useEffect(() => {
    if (fileUpload?.uploaded) {
      setShowButtons([]);
      setMessages((prev) => [
        ...prev.map((msg) => ({ ...msg })),

        {
          id: `assistant-${Date.now()}`,
          text: fileName,
          sender: "user",
          timestamp: new Date(),

          fileIcon: fileName && xlsxIcon,
        },
      ]);
    }
  }, [fileUpload?.uploaded]);

  const initialAgenticAICall = async (
    query: string,
    conversationId: any,
    extra_data?: any
  ) => {
    try {
      const feature = AgenticChatbotConstants.CONTRACT_DRAFTING;

      const mergedExtraData = {
        ...(extra_data || {}),
        oauth_token: accessToken ?? undefined,
      };

      const res = await initialPostCall(
        feature,
        query,
        conversationId,
        mergedExtraData
      );

      return res;
    } catch (err) {
      console.error(err);
      return AgenticChatbotConstants.SOMETHING_WENT_WRONG;
    }
  };

  const handleClose = () => {
    // if(fileId || fileIdReview){
    //   dispatch(storeFileId({ fileId: fileId , fileNameResponse: fileNameResponse })); // <-- Updated to include fileNameResponse

    // }
    dispatch(storeDocId(""));
    setFileId("");
    dispatch({
      type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
      payload: {
        file_name: "",
        docId: "",
        fileUpload: {
          error: {},
          uploaded: false,
        },
      },
    });
    dispatch({
      type: CONTRACT_REVIEW_ACTIONS.DELETE_DOCUMENT_ID,
      payload: {
        file_name: "",
        docId: "",
      },
    });
    setMessages([
      // {
      //   id: `assistant-0`,
      //   text: "",
      //   sender: "",
      //   timestamp: new Date(),
      //   fileIcon: "",
      // },
    ]);
    setShowButtons([]);
    hasRunOnceRef.current = false; // <-- Reset this!

    toggleDrawer(!isOpen)();
  };

  const handleConversationHistoryClick = () => {
    // setShowConversationHistory(!showConversationHistory);
    dispatch(updateConvHistoryShowStatusThunk(!showConversationHistory));
  };

  const handleNewChatClick = () => {
    setMessages([]);
    // setChatHistory([]);
    dispatch(storeChatHistory([]));
    setShowButtons([]);
    const newChatId = uuidv4();

    localStorage.setItem(LOCAL_STORAGE_KEYS.AGENTIC_CONVERSATION_ID, newChatId);
    setActiveConversationId(newChatId);
    hasRunOnceRef.current = false;
    dispatch(handleUseEffectCount(true));
  };

  const handlePreviousConversationClick = async (convId: string) => {
    setMessages([]);
    // setChatHistory([]);
    dispatch(storeChatHistory([]));
    dispatch(updateConvHistoryShowStatusThunk(false));

    const res = await getChatHistory({ current_session: convId });
    // setChatHistory(res);
    dispatch(storeChatHistory(res));
    setActiveConversationId(convId);
  };

  useEffect(() => {
    if (!docId) return;

    // if (docId !== prevDocIdRef.current) {
    // prevDocIdRef.current = docId;
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    setMessages((prev) => [
      ...prev,
      {
        id: loaderMsgId,
        text: "",
        sender: "assistant",
        timestamp: new Date(),
        loading: true,
        generating: true,
      },
    ]);
    dispatch(saveLoaderState({ generating: true }));
    setShowButtons([]);
    setIsCallPending(true);
    const fetchMessages = async () => {
      try {
        const feature = AgenticChatbotConstants.CONTRACT_DRAFTING;
        const query = reviewButtonClicked
          ? AgenticChatbotConstants.REVIEW_CONTRACT
          : AgenticChatbotConstants.DRAFT_CONTRACT;
        const extra_data = reviewButtonClicked
          ? { doc_id: "", oauth_token: accessToken }
          : {
              doc_id: docId,
              oauth_token: accessToken,
              file_name: fileName + ".xlsx",
            };
        const response = await initialPostCall(
          feature,
          query,
          activeConversationId,
          extra_data
        );

        if (response.status) {
          setMessages((prev) => {
            // First, set every message's hasUploadButton to false
            const updatedMessages = prev.map((msg) => ({
              ...msg,

              // hasReviewButton: false,
            }));
            setShowButtons([]);
            // Then update just the loader message
            return updatedMessages.map((msg) =>
              msg.id === loaderMsgId
                ? {
                    ...msg,
                    text: response.error_message
                      ? response.error_message
                      : response.message_to_user,
                    loading: false,
                    // showReviewButton: reviewButtonClicked
                    //   ? false
                    //   : !response?.error_message && true,
                  }
                : msg
            );
          });
          setShowButtons(response?.list_of_suggested_options);
          setIsCallPending(false);
          // dispatch(storeFileId(response?.drafted_contract_file_id));
          if (!reviewButtonClicked && response.drafted_contract_file_id) {
            dispatch(
              storeFileId({
                fileId: response?.drafted_contract_file_id,
                fileNameResponse: response?.drafted_contract_file_name,
              })
            ); // <-- Updated to include fileNameResponse
            let url =
              ROUTES.clauseCheckDoc +
              "?url=" +
              response.drafted_contract_file_id;
            if (!response.error_message && response?.drafted_contract_file_id) {
              navigate(
                url +
                  "&backurl=" +
                  ROUTES.contractDrafting +
                  "&type=drafting_dashboard",
                { state: { keepDrawerOpen: true } }
              );
            }
          } else {
            dispatch(storeDocId(contractsReviewDocId || ""));
            if (
              !response.error_message &&
              response.contract_reviewed_file_id !== contractsReviewDocId &&
              response.contract_reviewed_doc_id
            ) {
              let url = ROUTES.doc + "?url=" + contractsReviewDocId;

              navigate(
                url +
                  "&backurl=" +
                  ROUTES.manageContracts +
                  "&tab=review_pending_dashboard",
                { state: { keepDrawerOpen: true } }
              );
            }
          }
        }
        // dispatch(storeFileId(response?.drafted_contract_file_id));

        // let url =
        //   ROUTES.clauseCheckDoc +
        //   "?url=" +
        //   response.file_id_drafted_contract;
        toggleDrawer(true)();
        // setReviewDocId(response.contract_reviewed_doc_id);
        setFileId(response?.drafted_contract_file_id);
        setFileName(response?.drafted_contract_file_name);
        if (response?.drafted_contract_file_id) {
          // dispatch(storeFileId(response?.drafted_contract_file_id));

          dispatch(saveLoaderState({ generating: false }));
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        setIsCallPending(false);
      }
    };
    fetchMessages();
  }, [docId, accessToken, reviewButtonClicked, isOpen]);

  const hasAppendedReviewFileRef = useRef(false);

  const handleUploadContract = async () => {
    dispatch(emptyList());
    setOpenModal(true);
    setUploadContractClicked(true);
    setReviewButtonClicked(true);
  };
  const reviewFetchMessages = async () => {
    const loaderMsgId = `assistant-loader-${Date.now()}`;

    try {
      const feature = AgenticChatbotConstants.CONTRACT_DRAFTING;
      const query = AgenticChatbotConstants.REVIEW_CONTRACT;

      const extra_data = {
        doc_id: selectedDocId ? selectedDocId : contractsReviewDocId,
        oauth_token: accessToken,
        file_name: (selectedFileName || reviewList[0]?.file_name) + ".docx",
      };
      const response = await initialPostCall(
        feature,
        query,
        activeConversationId,
        extra_data
      );
      dispatch(emptyList());
      if (!response.error_message) {
        setMessages((prev) => {
          // First, set every message's hasUploadButton to false
          const updatedMessages = prev.map((msg) => ({
            ...msg,
            loading: false,
            // hasReviewButton: false,
            contractReviewLoader: false,
          }));
          // dispatch(saveReviewingfState({ reviewing: false }));
          // Then update just the loader message
          return updatedMessages.map((msg) =>
            msg.id === loaderMsgId
              ? {
                  ...msg,
                  text: response.message_to_user,
                  loading: false,
                  // showReviewButton: reviewButtonClicked

                  //   : !response?.error_message && true,
                }
              : msg
          );
        });

        setShowButtons(response?.list_of_suggested_options);
        setSelectedDocId("");

        setIsCallPending(false);

        if (
          response.contract_reviewed_doc_id &&
          !response.error_message &&
          response.contract_reviewed_file_id
        ) {
          let url =
            ROUTES.doc +
            "?url=" +
            (selectedDocId ? selectedDocId : response.contract_reviewed_doc_id);

          navigate(
            url +
              "&backurl=" +
              ROUTES.manageContracts +
              "&tab=review_pending_dashboard",
            { state: { keepDrawerOpen: true } }
          );
        }
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsCallPending(false);
    }
  };
  useEffect(() => {
    if (!uploadContractClicked) return;
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    if (contractsReviewDocId) {
      setShowButtons([]);
      setMessages((prev) => [
        ...prev.map((msg) => ({ ...msg })),

        {
          id: `assistant-${Date.now()}`,
          text: reviewList[0]?.file_name,
          sender: "user",
          timestamp: new Date(),

          fileIcon: Doc,
        },
      ]);
      setMessages((prev) => [
        ...prev,
        {
          id: loaderMsgId,
          text: "",
          sender: "assistant",
          timestamp: new Date(),
          loading: true,
          contractReviewLoader: true,
        },
      ]);
      // dispatch(saveReviewingfState({ reviewing: true }));
      setShowButtons([]);
      setIsCallPending(true);
      reviewFetchMessages();
    }
  }, [uploadContractClicked, contractsReviewDocId]);

  useEffect(() => {
    if (!selectedDocId) return;
    const loaderMsgId = `assistant-loader-${Date.now()}`;

    if (selectedFileName) {
      setShowButtons([]);
      setMessages((prev) => [
        ...prev.map((msg) => ({ ...msg })),

        {
          id: `assistant-${Date.now()}`,
          text: selectedFileName,
          sender: "user",
          timestamp: new Date(),
          fileIcon: Doc,
        },
      ]);
    }
    setMessages((prev) => [
      ...prev,
      {
        id: loaderMsgId,
        text: "",
        sender: "assistant",
        timestamp: new Date(),
        loading: true,
        contractReviewLoader: true,
      },
    ]);
    // dispatch(saveReviewingfState({ reviewing: true }));
    setIsCallPending(true);
    reviewFetchMessages();
  }, [selectedDocId]);

  const handleRecentContractsClick = async () => {
    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: "Recent Contracts",
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);
    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
    };
    setShowButtons([]); // Resetting the buttons
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = AgenticChatbotConstants.REVIEW_RECENT_CONTRACTS;

      const response = await initialAgenticAICall(query, activeConversationId);

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user,
                radioFileList: response?.documents ?? [],

                loading: false,
                // hasReviewButton: false,
              }
            : msg
        )
      );
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }

      setIsCallPending(false);
    } catch (err) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId ? { ...msg, loading: false } : msg
        )
      );
    }
  };

  const handleSearch = async () => {
    setShowHistoryButton(true);
    setShowButtons([]); // Resetting the buttons
    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: "Search Contract",
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);

    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
      contractReviewLoader: false,
    };
    // dispatch(saveReviewingfState({ reviewing: false }));
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = AgenticChatbotConstants.SEARCH_CONTRACT;

      const response = await initialAgenticAICall(query, activeConversationId);
      // d) Update the loader message with the response

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user || "No response received",
                loading: false,
              }
            : msg
        )
      );
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
      setIsCallPending(false);
    } catch (error) {
      // fallback if something fails
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: "Error occurred. Please try again.",
                loading: false,
              }
            : msg
        )
      );
    }
  };

  const handleMainMenuClick = async () => {
    setShowButtons([]); // Resetting the buttons
    const userMsg: Message = {
      id: `user-${Date.now()}`,
      text: "Main Menu",
      sender: "user",
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);

    const loaderMsgId = `assistant-loader-${Date.now()}`;
    const loaderMsg: Message = {
      id: loaderMsgId,
      text: "",
      sender: "assistant",
      timestamp: new Date(),
      loading: true,
      contractReviewLoader: false,
    };
    // dispatch(saveReviewingfState({ reviewing: false }));
    setIsCallPending(true);
    setMessages((prev) => [...prev, loaderMsg]);

    try {
      const query = AgenticChatbotConstants.MAIN_MENU;

      const response = await initialAgenticAICall(query, activeConversationId);
      // d) Update the loader message with the response

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: response?.message_to_user || "No response received",
                loading: false,
              }
            : msg
        )
      );
      if (response?.list_of_suggested_options) {
        setShowButtons(response?.list_of_suggested_options);
      }
      setIsCallPending(false);
    } catch (error) {
      // fallback if something fails
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === loaderMsgId
            ? {
                ...msg,
                text: "Error occurred. Please try again.",
                loading: false,
              }
            : msg
        )
      );
    }
  };

  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, chatHistory]);

  // For seeing if the last message in chatHistory is radio and no other message after that!
  function getCombinedChat(chatHistory: any[] = [], messages: Message[] = []) {
    // Normalize both arrays to have a comparable timestamp and radioFileList
    const normalize = (msg: any) => {
      let radioFileList = msg.radioFileList;

      // If from chatHistory, try to parse agent_response_json
      if (!radioFileList && msg.agent_response_json) {
        try {
          // Try JSON5 first for more robust parsing
          const parsed = JSON5.parse(msg.agent_response_json);
          if (Array.isArray(parsed.documents)) {
            radioFileList = parsed.documents;
          }
        } catch (e) {
          // fallback: try regular JSON
          try {
            const parsed = JSON.parse(
              msg.agent_response_json.replace(/'/g, '"')
            );
            if (Array.isArray(parsed.documents)) {
              radioFileList = parsed.documents;
            }
          } catch {
            // fallback: do nothing
          }
        }
      }

      return {
        ...msg,
        radioFileList,
        _timestamp: new Date(msg.timestamp || msg.created_at).getTime(),
      };
    };

    const combined = [
      ...(chatHistory || []).map(normalize),
      ...(messages || []).map(normalize),
    ];

    // Sort by timestamp
    return combined.sort((a, b) => a._timestamp - b._timestamp);
  }

  const renderedMessage = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "13px",
        }}
      >
        {messages.map((message, idx) => {
          const isRenderable =
            message.loading ||
            (typeof message.text === "string" &&
              message.text.trim().length > 0) ||
            (Array.isArray(message.radioFileList) &&
              message.radioFileList.length > 0);

          if (!isRenderable) return null;
          return (
            <Box
              key={message?.id}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "row",
                maxWidth: "100%",
                borderTopRightRadius: "4px",
                borderTopLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                borderBottomLeftRadius: "16px",
                alignSelf:
                  message?.sender === "user" ? "flex-end" : "flex-start",
              }}
            >
              <Box
                sx={{
                  backgroundColor: message?.sender === "user" ? "#F2F4F7" : "",
                  borderTopRightRadius: "4px",
                  borderTopLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                  borderBottomLeftRadius: "16px",
                  padding: "1px 3px",
                  order: message.sender === "user" ? -1 : 0,
                  maxWidth: "100%",
                  display: "flex",
                  flexDirection: message.sender === "user" ? "row" : "column",
                  marginLeft: message?.fileIcon && "28px",
                }}
              >
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {message?.sender === "assistant" && (
                    <img
                      src={Orion}
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                        // marginTop: "4px",
                      }}
                      alt=""
                    />
                  )}

                  {message?.loading && message?.sender === "assistant" ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        maxWidth: "100%",
                        alignSelf: "flex-start",
                      }}
                    >
                      <div className={AgenticChatbot.botMessageLoaderContainer}>
                        {" "}
                        <div className={AgenticChatbot.botMessageLoader}>
                          {new Array(3).fill("").map((dot, index) => {
                            return (
                              <div
                                key={`dot-${index}`}
                                className={AgenticChatbot.dot}
                                style={{ animationDelay: `${index * 0.7}s` }}
                              ></div>
                            );
                          })}
                        </div>{" "}
                        <Typography fontSize={14} fontWeight={400}>
                          {fileUpload?.uploaded &&
                            message.generating &&
                            AgenticChatbotConstants.GENERATING_CONTRACT_DRAFT}
                          {((message.contractReviewLoader &&
                            contractsReviewFileUpload?.uploaded) ||
                            selectedDocId) &&
                            AgenticChatbotConstants.REVIEWING_CONTRACT_STEPS[
                              reviewStepIndex
                            ]}
                        </Typography>
                      </div>
                    </Box>
                  ) : (
                    (message.text ||
                      (message?.radioFileList &&
                        message.radioFileList.length > 0)) && (
                      <div
                        className={AgenticChatbot.messageTextContainer}
                        style={
                          message.sender === "user"
                            ? {
                                background:
                                  "var(--Background-Neutral-Subtle-3, #F2F4F7)",
                                padding: message.fileIcon ? "0px" : "6px 16px",
                                borderTopRightRadius: "4px",
                                borderTopLeftRadius: "16px",
                                borderBottomRightRadius: "16px",
                                borderBottomLeftRadius: "16px",
                              }
                            : {}
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            padding: message?.fileIcon ? "6px 16px" : "0px",
                          }}
                        >
                          {message?.fileIcon && (
                            <img
                              src={message.fileIcon}
                              alt=""
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "5px",
                              }}
                            />
                          )}
                          <Typography
                            fontSize={14}
                            fontWeight={400}
                            style={{
                              width: "100%",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {" "}
                            {message.text}
                          </Typography>
                        </div>
                        {message?.radioFileList &&
                          message?.radioFileList?.length > 0 && (
                            <div
                              style={{
                                overflowY: "auto",
                                overflowX: "hidden",
                                marginTop: "8px",
                                marginBottom: "8px",
                                // optional
                              }}
                            >
                              {(message?.radioFileList).map(
                                (doc: any, idx: number) => (
                                  <label
                                    key={doc?.doc_id || idx}
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="recentFile"
                                      value={doc?.doc_id}
                                      onChange={() => {
                                        setSelectedDocId(doc?.doc_id);
                                        setSelectedFileName(doc?.file_name);
                                      }}
                                      disabled={
                                        Boolean(inputValue) ||
                                        (Boolean(selectedDocId) &&
                                          selectedDocId !== doc?.doc_id)
                                      }
                                    />

                                    <Typography
                                      fontSize={14}
                                      fontWeight={400}
                                      style={{
                                        width: "85%",
                                        overflowWrap: "anywhere",
                                        marginLeft: "8px",
                                      }}
                                    >
                                      {doc?.file_name}
                                    </Typography>
                                  </label>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    )
                  )}
                </div>
                {idx === messages?.length - 1 &&
                  showButtons &&
                  showButtons.length > 0 && (
                    <>
                      {" "}
                      {showButtons?.includes("Main Menu") && (
                        <Button
                          variant="outlined"
                          onClick={handleMainMenuClick}
                          style={{
                            borderRadius: "24px",
                            height: "20px",
                            marginTop: "5px",
                            padding: "0px 16px",
                            marginLeft: "25px",
                            width: "fit-content",
                          }}
                        >
                          <Typography
                            style={{ fontSize: "10px", fontWeight: 600 }}
                          >
                            {AgenticChatbotConstants.MAIN_MENU}
                          </Typography>
                        </Button>
                      )}
                    </>
                  )}
                {idx === messages?.length - 1 &&
                  showButtons &&
                  showButtons.length > 0 && (
                    <>
                      {showButtons?.includes("Upload Intake Form") && (
                        <Button
                          variant="outlined"
                          onClick={handleUploadClick}
                          style={{
                            borderRadius: "24px",
                            height: "20px",
                            marginTop: "5px",
                            padding: "0px 8px",
                            marginLeft: "25px",
                            width: "fit-content",
                          }}
                        >
                          <img
                            src={UploadIcon}
                            style={{ height: "12px", paddingRight: "5px" }}
                            alt=""
                          ></img>{" "}
                          <Typography
                            style={{ fontSize: "10px", fontWeight: 600 }}
                          >
                            {AgenticChatbotConstants.UPLOAD_INTAKE_FORM}
                          </Typography>
                        </Button>
                      )}
                    </>
                  )}

                {idx === messages?.length - 1 &&
                  showButtons &&
                  showButtons.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",

                        marginLeft: "19px",
                        gap: "0.2rem",
                      }}
                    >
                      {showButtons?.includes("Recent contracts") && (
                        <Button
                          variant="outlined"
                          onClick={handleRecentContractsClick}
                          style={{
                            borderRadius: "24px",
                            height: "20px",
                            marginTop: "5px",
                            padding: "0px 8px",

                            width: "fit-content",
                          }}
                        >
                          <Typography
                            style={{ fontSize: "10px", fontWeight: 600 }}
                          >
                            {AgenticChatbotConstants.RECENT_CONTRACTS}
                          </Typography>
                        </Button>
                      )}
                      {showButtons?.includes("Search") && (
                        <Button
                          variant="outlined"
                          onClick={handleSearch}
                          style={{
                            borderRadius: "24px",
                            height: "20px",
                            marginTop: "5px",
                            padding: "0px 8px",

                            width: "fit-content",
                          }}
                        >
                          <Typography
                            style={{ fontSize: "10px", fontWeight: 600 }}
                          >
                            {AgenticChatbotConstants.SEARCH}
                          </Typography>
                        </Button>
                      )}
                      {showButtons?.includes("Upload Contract") && (
                        <Button
                          variant="outlined"
                          onClick={handleUploadContract}
                          style={{
                            borderRadius: "24px",
                            height: "20px",
                            marginTop: "5px",
                            padding: "0px 10px",
                            justifyContent: "start",
                            width: "fit-content",
                          }}
                        >
                          <Typography
                            style={{ fontSize: "10px", fontWeight: 600 }}
                          >
                            {AgenticChatbotConstants.UPLOAD_CONTRACT}
                          </Typography>
                        </Button>
                      )}
                    </div>
                  )}
              </Box>
            </Box>
          );
        })}
        {showButtons && showButtons.length > 0 && (
          <div className={AgenticChatbot.btnContainer}>
            {showButtons?.includes("Draft Contract") && (
              <Button
                variant="outlined"
                style={{
                  borderRadius: "24px",
                  height: "20px",
                }}
                onClick={handleDraftContractClick}
              >
                <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                  {AgenticChatbotConstants.DRAFT_CONTRACT}
                </Typography>
              </Button>
            )}

            {showButtons?.includes("Review Contract") && (
              <Button
                variant="outlined"
                style={{
                  borderRadius: "24px",
                  height: "20px",
                }}
                onClick={handleReviewContractClick}
              >
                <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                  {AgenticChatbotConstants.REVIEW_CONTRACT}
                </Typography>
              </Button>
            )}
            {showButtons?.includes("Review Contract Initial") && (
              <Button
                variant="outlined"
                style={{
                  borderRadius: "24px",
                  height: "20px",
                }}
                onClick={handleReviewContractClickInitial}
              >
                <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                  {AgenticChatbotConstants.REVIEW_CONTRACT}
                </Typography>
              </Button>
            )}
          </div>
        )}
        <div ref={bottomRef}></div>
      </div>
    );
  };
  const list = (
    removeHeader: boolean,
    showMessage: boolean,
    showFooter: boolean
  ) => (
    <Box role="presentation" style={{ height: "100%" }}>
      {showConversationHistory && (
        <ConversationHistory
          handleClose={handleClose}
          handleConversationHistoryClick={handleConversationHistoryClick}
          showConversationHistory={showConversationHistory}
          handlePreviousConversationClick={handlePreviousConversationClick}
        />
      )}
      {removeHeader && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            paddingBottom: "0px",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            {AgenticChatbotConstants.ASK_ASTRO}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <img src={NewChatIcon} onClick={handleNewChatClick} alt="" />
            <img
              src={ConversationHistoryIcon}
              alt=""
              onClick={handleConversationHistoryClick}
            />
            <img src={CloseIcon} alt="" onClick={handleClose} color="red" />
          </Box>
        </Box>
      )}
      <Box
        sx={{
          backgroundImage: `url(${ChatbotBackground})`,
          width: "330px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          borderRadius: "16px",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "13px",
          marginTop: "15px",
          marginBottom: "8px",
          height: "90%",
          justifyContent: "end",
          overflowY: "auto",
          scrollbarWidth: "none", // For Firefox
          msOverflowStyle: "none", // For Internet Explorer and Edge
          "&::-webkit-scrollbar": {
            display: "none", // For Chrome, Safari, and Opera
          },
        }}
      >
        <Box
          //  ref={chatContainerRef}
          sx={{
            display: "flex",
            flexDirection:
              (chatHistory?.length ?? 0) > 0 ? "column" : "column-reverse",

            height: "100%",
            overflowY: "auto",
            scrollbarWidth: "none", // For Firefox
          }}
        >
          {renderedMessage()}
        </Box>
      </Box>
      {showFooter && (
        <div style={{ width: "100%" }}>
          {" "}
          <SearchInput
            placeholder="Search or Ask Orion"
            onSearch={handleUserMessage}
            value={inputValue}
            onChange={handleInputChange}
            sideDrawer={true}
            disabled={isCallPending}
          />
        </div>
      )}
    </Box>
  );
  const [options, setOptions] = useState<string[]>([]);
  useEffect(() => {
    if (chatHistory && chatHistory.length > 0) {
      const lastMsg = chatHistory[chatHistory.length - 1];
      let newOptions: string[] = [];
      if (lastMsg.agent_response_json) {
        try {
          const parsed = JSON.parse(
            lastMsg.agent_response_json.replace(/'/g, '"')
          );
          newOptions = parsed.list_of_suggested_options || [];
        } catch (e) {
          newOptions = [];
        }
      }
      setOptions(newOptions);
    } else {
      setOptions([]);
    }
  }, [chatHistory]);
  const chatHistoryList = () => {
    function parseAgentResponse(jsonStr: string): any {
      if (!jsonStr || typeof jsonStr !== "string") return {};
      try {
        return JSON.parse(jsonStr);
      } catch {
        try {
          return JSON5.parse(jsonStr);
        } catch (err) {
          console.warn("Failed to parse agent_response_json:", jsonStr, err);
          return {};
        }
      }
    }

    const combinedChat = getCombinedChat(chatHistory ?? [], messages);
    const lastMessage = combinedChat[combinedChat.length - 1];
    const isLastRadio =
      Array.isArray(lastMessage?.radioFileList) &&
      lastMessage.radioFileList.length > 0;

    const renderButtons = (agentResponse = null) => (
      <div className={AgenticChatbot.btnContainer}>
        {options?.includes("Main Menu") && (
          <Button
            variant="outlined"
            onClick={handleMainMenuClick}
            style={{
              borderRadius: "24px",
              height: "20px",
              marginTop: "5px",
              padding: "0px 16px",
              marginLeft: "25px",
              width: "fit-content",
            }}
          >
            <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
              {AgenticChatbotConstants.MAIN_MENU}
            </Typography>
          </Button>
        )}
        {options?.includes("Upload Intake Form" as string) && (
          <Button
            variant="outlined"
            onClick={handleUploadClick}
            style={{
              borderRadius: "24px",
              height: "20px",
              marginTop: "5px",
              padding: "0px 8px",

              width: "fit-content",
            }}
          >
            <img
              src={UploadIcon}
              style={{ height: "12px", paddingRight: "5px" }}
              alt=""
            />
            <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
              {AgenticChatbotConstants.UPLOAD_INTAKE_FORM}
            </Typography>
          </Button>
        )}

        {options?.includes("Draft Contract") && (
          <Button
            variant="outlined"
            style={{
              borderRadius: "24px",
              height: "20px",
            }}
            onClick={handleDraftContractClick}
          >
            <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
              {AgenticChatbotConstants.DRAFT_CONTRACT}
            </Typography>
          </Button>
        )}

        {options?.includes("Review Contract") && (
          <Button
            variant="outlined"
            style={{
              borderRadius: "24px",
              height: "20px",
            }}
            onClick={() => handleReviewContractClick(agentResponse)}
          >
            <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
              {AgenticChatbotConstants.REVIEW_CONTRACT}
            </Typography>
          </Button>
        )}
        {options?.includes("Review Contract Initial") && (
          <Button
            variant="outlined"
            style={{
              borderRadius: "24px",
              height: "20px",
            }}
            onClick={handleReviewContractClickInitial}
          >
            <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
              {AgenticChatbotConstants.REVIEW_CONTRACT}
            </Typography>
          </Button>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",

            gap: "0.2rem",
          }}
        >
          {options?.includes("Recent contracts") && (
            <Button
              variant="outlined"
              onClick={handleRecentContractsClick}
              style={{
                borderRadius: "24px",
                height: "20px",
                marginTop: "5px",
                padding: "0px 8px",

                width: "fit-content",
              }}
            >
              <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                {AgenticChatbotConstants.RECENT_CONTRACTS}
              </Typography>
            </Button>
          )}
          {options?.includes("Search") && (
            <Button
              variant="outlined"
              onClick={handleSearch}
              style={{
                borderRadius: "24px",
                height: "20px",
                marginTop: "5px",
                padding: "0px 8px",

                width: "fit-content",
              }}
            >
              <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                {AgenticChatbotConstants.SEARCH}
              </Typography>
            </Button>
          )}
          {options?.includes("Upload Contract") && (
            <Button
              variant="outlined"
              onClick={handleUploadContract}
              style={{
                borderRadius: "24px",
                height: "20px",
                marginTop: "5px",
                padding: "0px 10px",
                justifyContent: "start",
                width: "fit-content",
              }}
            >
              <Typography style={{ fontSize: "10px", fontWeight: 600 }}>
                {AgenticChatbotConstants.UPLOAD_CONTRACT}
              </Typography>
            </Button>
          )}
        </div>
      </div>
    );
    return (
      <Box role="presentation" style={{ height: "100%" }}>
        {showConversationHistory && (
          <ConversationHistory
            handleClose={handleClose}
            handleConversationHistoryClick={handleConversationHistoryClick}
            showConversationHistory={showConversationHistory}
            handlePreviousConversationClick={handlePreviousConversationClick}
          />
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "0px",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            {AgenticChatbotConstants.ASK_ASTRO}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <img src={NewChatIcon} onClick={handleNewChatClick} alt="" />
            <img
              src={ConversationHistoryIcon}
              alt=""
              onClick={handleConversationHistoryClick}
            />
            <img src={CloseIcon} alt="" onClick={handleClose} color="red" />
          </Box>
        </Box>

        <Box
          sx={{
            backgroundImage: `url(${ChatbotBackground})`,
            width: "330px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            borderRadius: "16px",
            padding: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "13px",
            marginTop: "15px",
            marginBottom: "8px",
            height: "90%",
            justifyContent: "end",
            overflowY: "auto",
            scrollbarWidth: "none", // For Firefox
            msOverflowStyle: "none", // For Internet Explorer and Edge
            "&::-webkit-scrollbar": {
              display: "none", // For Chrome, Safari, and Opera
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "100%",
              overflowY: "auto",
              scrollbarWidth: "none", // For Firefox
              gap: "13px",
            }}
          >
            <>
              {(chatHistory ?? [])
                .sort(
                  (a, b) =>
                    new Date(a.created_at).getTime() -
                    new Date(b.created_at).getTime()
                )
                .map((msg, idx, arr) => {
                  /* ─────── OUTER ROW ─────── */
                  // Parse agent_response_json
                  const agentResponse = parseAgentResponse(
                    msg.agent_response_json
                  );
                  const radioFileList = agentResponse.documents || [];

                  return (
                    <Box
                      key={msg.id}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        maxWidth: "100%",
                        alignSelf:
                          msg.role === "user" ? "flex-end" : "flex-start",
                        marginLeft: "3px",
                      }}
                    >
                      {/* ─────── BUBBLE ─────── */}
                      <Box
                        sx={{
                          backgroundColor: msg.role === "user" ? "#F2F4F7" : "",
                          borderTopRightRadius: 4,
                          borderTopLeftRadius: 16,
                          borderBottomRightRadius: 16,
                          borderBottomLeftRadius: 16,
                          p: "1px 0px",
                          order: msg.role === "user" ? -1 : 0, // user bubbles shift to the right
                          maxWidth: "100%",
                          display: "flex",
                          flexDirection: msg.role === "user" ? "row" : "column",
                          marginLeft:
                            (/\.xlsx|\.docx/gi.test(msg.message_text) &&
                              "18px") ||
                            "0px",
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          {msg.role === "agent" && (
                            <img
                              src={Orion}
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                              }}
                              alt=""
                            />
                          )}

                          <div
                            className={AgenticChatbot.messageTextContainer}
                            style={
                              msg.role === "user"
                                ? {
                                    background:
                                      "var(--Background-Neutral-Subtle-3, #F2F4F7)",
                                    padding: "6px 16px",
                                    borderTopRightRadius: "4px",
                                    borderTopLeftRadius: "16px",
                                    borderBottomRightRadius: "16px",
                                    borderBottomLeftRadius: "16px",
                                  }
                                : {}
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection:
                                  radioFileList.length > 0 ? "column" : "row",
                              }}
                            >
                              {/\.xlsx|\.docx/gi.test(msg.message_text) && (
                                <img
                                  src={
                                    /\.docx/gi.test(msg.message_text)
                                      ? Doc
                                      : xlsxIcon
                                  }
                                  alt=""
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    marginRight: "5px",
                                  }}
                                />
                              )}
                              <Typography
                                fontSize={14}
                                fontWeight={400}
                                style={{
                                  width: "100%",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {msg.message_text.replace(
                                  /\.xlsx|\.docx/gi,
                                  ""
                                )}
                              </Typography>

                              {radioFileList.length > 0 && (
                                <div
                                  style={{
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    marginTop: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  {(radioFileList as ChatHistoryDocument[]).map(
                                    (doc: ChatHistoryDocument, idx: number) => (
                                      <label
                                        key={doc.doc_id || idx}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name={`recentFile-history-${msg.id}`}
                                          value={doc.doc_id}
                                          disabled={!isLastRadio}
                                          onChange={() => {
                                            setSelectedDocId(doc?.doc_id);
                                            setSelectedFileName(doc?.file_name);
                                          }}
                                        />
                                        <Typography
                                          fontSize={14}
                                          fontWeight={400}
                                          style={{
                                            width: "85%",
                                            overflowWrap: "anywhere",
                                            marginLeft: "8px",
                                          }}
                                        >
                                          {doc.file_name}
                                        </Typography>
                                      </label>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {idx === arr.length - 1 &&
                          options.length > 0 &&
                          renderButtons(agentResponse)}
                      </Box>
                    </Box>
                  );
                })}
              {renderedMessage()}
            </>
          </Box>
        </Box>

        <div style={{ width: "100%" }}>
          {" "}
          <SearchInput
            placeholder="Search or Ask Orion"
            onSearch={handleUserMessage}
            value={inputValue}
            onChange={handleInputChange}
            sideDrawer={true}
            disabled={isCallPending}
          />
        </div>
      </Box>
    );
  };

  const combinedList =
    (chatHistory?.length ?? 0) > 0
      ? [chatHistoryList()]
      : [list(true, true, true)];
  console.log("hello", showButtons);

  return (
    <React.Fragment>
      <SideDrawer
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        list={() => combinedList}
        onClose={handleClose}
      />
      <UploadDoc
        openModal={openModal}
        setOpenModal={setOpenModal}
        dashboardEntity={
          showButtons?.includes("Upload Contract") || reviewButtonClicked
            ? DASHBOARD_ENTITIES.CONTRACT_REVIEW
            : DASHBOARD_ENTITIES.CONTRACT_DRAFTING
        }
        onFileUpload={handleFileUpload}
        callFromChatbot={true}
      />
    </React.Fragment>
  );
}
